
import { useState } from 'react';

const Hero = () => {
  const [showGiftSection, setShowGiftSection] = useState(true);

  const scrollToProducts = () => {
    const productsSection = document.getElementById('products');
    if (productsSection) {
      productsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home" 
      className="relative py-20 overflow-hidden"
    >
      {/* 배경 이미지들 */}
      <div className="absolute inset-0 flex">
        <div 
          className="w-1/2 h-full"
          style={{
            backgroundImage: `linear-gradient(rgba(251, 191, 36, 0.1), rgba(251, 146, 60, 0.1)), url('https://static.readdy.ai/image/ce2a556e276a3afd2385ae1ca37a15ee/f5b4bc70cd98e5246b08e4ff6fca0666.jfif')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        ></div>
        <div 
          className="w-1/2 h-full"
          style={{
            backgroundImage: `linear-gradient(rgba(251, 191, 36, 0.1), rgba(251, 146, 60, 0.1)), url('https://static.readdy.ai/image/ce2a556e276a3afd2385ae1ca37a15ee/ca733c9c30fedd437442432dad2c6e8d.jfif')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        ></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Main Content */}
          <div 
            className="bg-white/95 backdrop-blur-sm rounded-3xl p-12 shadow-2xl cursor-pointer" 
            onClick={scrollToProducts}
          >
            <div className="mb-8">
              <span className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-full text-sm font-semibold mb-6">
                <i className="ri-vip-crown-line mr-2"></i>
                20년 장인의 고집
              </span>
              <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-orange-600">
                  명품을 선물하세요
                </span>
              </h1>
              <p className="text-xl text-gray-700 mb-8 leading-relaxed">
                최고의 원물만을 고집하여 최상의 퀄리티를 20년간 담았습니다.<br />
                비교불가한 맛과 향은 물론, 건강까지 생각한 <strong>한의사 노태균 원장</strong>의 역작
              </p>
            </div>

            <div className="bg-gradient-to-r from-red-50 to-orange-50 border-2 border-red-200 rounded-2xl p-8 mb-8">
              <div className="flex items-center justify-center mb-4">
                <i className="ri-gift-line text-red-500 text-3xl mr-3"></i>
                <h3 className="text-2xl font-bold text-red-700">추석맞이 회원 특별가</h3>
              </div>
              <p className="text-red-600 text-lg font-semibold">
                🎯 20% 할인 혜택으로 최고의 품격을 더욱 합리적으로
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={scrollToProducts}
                className="bg-gradient-to-r from-amber-500 to-orange-500 text-white px-8 py-4 rounded-full hover:shadow-lg transition-all text-lg font-semibold whitespace-nowrap cursor-pointer"
              >
                <i className="ri-shopping-cart-line mr-2"></i>
                지금 주문하기
              </button>
              <button 
                onClick={scrollToProducts}
                className="border-2 border-amber-500 text-amber-600 px-8 py-4 rounded-full hover:bg-amber-50 transition-all text-lg font-semibold whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                010-6607-5556
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
